module.exports = __webpack_public_path__ + "img/exclamation-mark-roundedline.ba3d4a53.svg";